"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateService = void 0;
const _1 = require("./");
const dayjs = require("dayjs");
const localizedFormat = require("dayjs/plugin/localizedFormat");
const localeData = require("dayjs/plugin/localeData");
const bgLocale = require("dayjs/locale/bg");
const csLocale = require("dayjs/locale/cs");
const daLocale = require("dayjs/locale/da");
const deATLocale = require("dayjs/locale/de-at");
const deCHLocale = require("dayjs/locale/de-ch");
const deLocale = require("dayjs/locale/de");
const enAULocale = require("dayjs/locale/en-au");
const enCALocale = require("dayjs/locale/en-ca");
const enGBLocale = require("dayjs/locale/en-gb");
const enINLocale = require("dayjs/locale/en-in");
const enSGLocale = require("dayjs/locale/en-SG");
const esLocale = require("dayjs/locale/es");
const etLocale = require("dayjs/locale/et");
const fiLocale = require("dayjs/locale/fi");
const frLocale = require("dayjs/locale/fr");
const frCHLocale = require("dayjs/locale/fr-ch");
const hrLocale = require("dayjs/locale/hr");
const huLocale = require("dayjs/locale/hu");
const isLocale = require("dayjs/locale/is");
const itLocale = require("dayjs/locale/it");
const koLocale = require("dayjs/locale/ko");
const ltLocale = require("dayjs/locale/lt");
const lvLocale = require("dayjs/locale/lv");
const nbLocale = require("dayjs/locale/nb");
const nlBELocale = require("dayjs/locale/nl-be");
const nlLocale = require("dayjs/locale/nl");
const plLocale = require("dayjs/locale/pl");
const ptLocale = require("dayjs/locale/pt");
const roLocale = require("dayjs/locale/ro");
const ruLocale = require("dayjs/locale/ru");
const skLocale = require("dayjs/locale/sk");
const slLocale = require("dayjs/locale/sl");
const srLocale = require("dayjs/locale/sr");
const svLocale = require("dayjs/locale/sv");
const trLocale = require("dayjs/locale/tr");
const ukLocale = require("dayjs/locale/uk");
const zhCNLocale = require("dayjs/locale/zh-cn");
const zhTWLocale = require("dayjs/locale/zh-tw");
const localesMapping = {
    bg: bgLocale,
    cs: csLocale,
    da: daLocale,
    'de-at': deATLocale,
    'de-ch': deCHLocale,
    de: deLocale,
    'en-au': enAULocale,
    'en-ca': enCALocale,
    'en-gb': enGBLocale,
    'en-in': enINLocale,
    'en-sg': enSGLocale,
    es: esLocale,
    et: etLocale,
    fi: fiLocale,
    fr: frLocale,
    'fr-ch': frCHLocale,
    hr: hrLocale,
    hu: huLocale,
    is: isLocale,
    it: itLocale,
    ko: koLocale,
    lt: ltLocale,
    lv: lvLocale,
    nb: nbLocale,
    'nl-be': nlBELocale,
    nl: nlLocale,
    pl: plLocale,
    pt: ptLocale,
    ro: roLocale,
    ru: ruLocale,
    sk: skLocale,
    sl: slLocale,
    sr: srLocale,
    sv: svLocale,
    tr: trLocale,
    uk: ukLocale,
    'zh-cn': zhCNLocale,
    'zh-tw': zhTWLocale,
};
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
class DateService {
    static getTimestamp() {
        return Date.now();
    }
}
exports.DateService = DateService;
DateService.setLocale = (locale) => {
    const localeLowerCase = locale.toLowerCase();
    const language = _1.UtilService.parseLanguageCode(localeLowerCase);
    const dayjsLocale = localesMapping[localeLowerCase] || localesMapping[language];
    dayjs.locale(dayjsLocale);
};
DateService.getWeekdays = () => {
    return dayjs().localeData().weekdays();
};
DateService.formatDate = (date, formatPattern = 'dddd, LL') => {
    return dayjs(date).format(formatPattern);
};
DateService.getTodayISOString = () => {
    const date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString();
};
